<template>
  <div class="container page" style="background: #1f1c1f;">
    <div class="header">
      <van-nav-bar :title="$t('withdraw.with_record')" class="nav-bar">
        <template #left>
          <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
        </template>
        <template #right>
          <van-icon name="wap-home-o" color="#937960" size="26" @click="goHome" />
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        :pulling-text="$t('index.loading')"
        :loosing-text="$t('index.loading')"
        :loading-text="$t('index.loading')"
      >
          <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
          <div v-else class="table">
            <div class="list" v-for="(v,key) in list" :key="key">
              <ul>
                <li class="w50 tl">
                  <span :class="{
                    'success': v.status === 2 || v.status === 4,
                    'failed': v.status === 3
                  }">{{v.status_text}}</span>
                </li>
                <li class="w50 tr time">{{v.create_time}}</li>
                <li class="money-row">
                  <span class="money-item">{{formatMoney(v.money)}}</span>
                  <span class="money-item">{{$t("withdraw.commission")}}0</span>
                  <span class="money-item">{{$t("withdraw.actual_arrival")}}{{formatMoney(v.money)}}</span>
                </li>
                <li class="desc">
                  <span>{{$t("withdraw.desc")}}：{{v.desc}}</span>
                </li>
              </ul>
            </div>
          </div>
      </van-pull-refresh>
    </div>
    <!-- <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
          <div v-else class="item_list" v-for="(v,key) in list" :key="key">
            <div class="topInfo">
              <span v-if="v.status === 2" style="color: #07c160">{{v.status_text}}</span>
              <span v-else-if="v.status === 4" style="color: #07c160">{{v.status_text}}</span>
              <span v-else >{{v.status_text}}</span>
              <span>{{$t("withdraw.money")}}：-{{v.money}}</span>
            </div>
            <div class="desc">
              <span>{{$t("withdraw.desc")}}：{{v.desc}}</span>
            </div>
            <div class="time">
              <span>{{$t("withdraw.submit_time")}}：{{v.create_time}}</span>
            </div>
            <div class="time">
              <span>{{$t("withdraw.check_time")}}：{{v.update_time}}</span>
            </div>
          </div>
      </van-pull-refresh>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      list:[]
    };
  },
  methods: {
    formatMoney(money) {
      if (!money) return '0';
      return Math.floor(parseFloat(money)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    back(){
      return window.history.back();
    },
    goHome() {
      this.$router.push('/');
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserWithdrawList(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_list'
      }).then(res=>{
        if(res.code === 200){
          this.list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserWithdrawList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #f3c7a2;
  font-size: 28px;
}

::v-deep .van-loading__text {
  color: #f3c7a2;
  font-size: 28px;
}

.container .main{
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 15px;
}

.table .list ul {
  line-height: 4vw;
  font-size: 3.8vw;
  padding: 3vw;
  overflow: hidden;
  border: 1px solid #766350;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 2vw;
  margin-bottom: 2.5vw;
}

.w50 {
  float: left;
  width: 50%;
}

.tl {
  text-align: left;
  font-size: 4vw;
  color: #f3c7a2;
}

.tr {
  text-align: right;
}

.time {
  color: #999;
  font-size: 3.5vw;
}

.success {
  color: #07c160;
}

.failed {
  color: #ff4d4f;
}

.money-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4vw 4vw;
  margin: 1vw 0;
  border-bottom: 1px solid rgba(118, 99, 80, 0.2);
  clear: both;
  gap: 2vw;
}

.money-item {
  flex: 1;
  text-align: center;
  color: #fff;
  font-size: 3.2vw;
  white-space: nowrap;
  &:first-child {
    text-align: left;
    max-width: 25%;
  }
  &:nth-child(2) {
    max-width: 30%;
  }
  &:last-child {
    text-align: right;
    max-width: 35%;
  }
}

.desc {
  padding: 2vw 0;
  color: #999;
  font-size: 3.5vw;
  clear: both;
}
</style>
